import React from "react";
import Moment from "moment-timezone";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { IScheduleLog } from "../../../types/stores/schedules";

type Props = {
    entry: IScheduleLog;
    windowsToIanaTimezoneMap: { [key: string]: string };
};

const ScheduleLogEntry: React.FC<Props> = ({ entry, windowsToIanaTimezoneMap }: Props) => {
    // Adding +0000 forces the timestamp to be understood as UTC.
    let parsedCreatedDate = Moment(entry.WhenUTC + "+0000");
    let timezoneUsed: string | null = null;
    if (entry && entry.Timezone && windowsToIanaTimezoneMap && windowsToIanaTimezoneMap[entry.Timezone]) {
        timezoneUsed = windowsToIanaTimezoneMap[entry.Timezone];
        parsedCreatedDate = parsedCreatedDate.tz(timezoneUsed);
    } else {
        parsedCreatedDate = parsedCreatedDate.local();
    }

    return entry ? (
        <TableBody>
            <TableRow>
                <TableCell style={{ fontSize: 15, width: 200 }} align="center">
                    {parsedCreatedDate.format("MMMM Do YYYY, h:mm:ss a")}
                    <br />
                    {timezoneUsed ? (
                        <span style={{ color: "#AAA" }}>({timezoneUsed})</span>
                    ) : (
                        <span style={{ color: "#AAA" }}>(local browser time)</span>
                    )}
                </TableCell>
                <TableCell style={{ fontSize: 15, width: 200 }} align="center">
                    {entry.Message}
                </TableCell>
                <TableCell style={{ fontSize: 15, width: 200 }} align="center">
                    {entry.Success ? (
                        <span className="text-success">
                            <strong>Success</strong>
                        </span>
                    ) : (
                        <span className="text-danger">
                            <strong>Error</strong>
                        </span>
                    )}
                </TableCell>
            </TableRow>
        </TableBody>
    ) : null;
};

export default ScheduleLogEntry;
